import Link from "next/link"
import { Routes } from "@blitzjs/next"
import { FC, useState } from "react"
import tw from "tailwind-styled-components"

export const SectionHeader = tw.h5`
  text-3xl
  py-2
`

export const SectionSubHeader = tw.h5`
  text-2xl
  mt-6
  font-semibold
  py-3
`

export const SectionSubHeader2 = tw.h5`
  text-xl
  mt-2
  font-semibold
  py-1
`

export const SectionPara = tw.p`
  text-lg
  leading-loose
  py-2
`

export const ItemList: FC<{ listElements: string[] }> = ({ listElements }) => {
  return (
    <ul className="list-disc text-lg ml-12 leading-10 my-3">
      {listElements.map((e, i) => (
        <li key={e}>{e}</li>
      ))}
    </ul>
  )
}

export enum PrivacyPageType {
  POLICY,
  TERMS,
  GDPR,
  DPA,
  SUB_PROCESSORS,
}

export const SideNav = ({ page }: { page: PrivacyPageType }) => {
  return (
    (<aside className="mx-8 hidden lg:block sticky t-[75px]">
      <Link href={Routes.Privacy()} legacyBehavior>
        <div
          className={`py-1 my-3 px-3 cursor-pointer transition ${
            page === PrivacyPageType.POLICY
              ? "border-l-4 border-brand-primary"
              : "border-l-4 hover:border-opacity-10 text-white/40 hover:text-white hover:border-white border-transparent "
          }`}
        >
          <h5 className="text-lg opacity-100 whitespace-nowrap"> Privacy Policy </h5>
        </div>
      </Link>
      <Link href={Routes.Terms()} legacyBehavior>
        <div
          className={`py-1 my-3 px-3 cursor-pointer transition ${
            page === PrivacyPageType.TERMS
              ? "border-l-4 border-brand-primary"
              : "border-l-4 hover:border-opacity-10 text-white/40 hover:text-white hover:border-white border-transparent "
          }`}
        >
          <h5 className="text-lg opacity-100 whitespace-nowrap"> Terms and Conditions </h5>
        </div>
      </Link>
      <Link href={Routes.GDPR()} legacyBehavior>
        <div
          className={`py-1 my-3 px-3 cursor-pointer transition ${
            page === PrivacyPageType.GDPR
              ? "border-l-4 border-brand-primary"
              : "border-l-4 hover:border-opacity-10 text-white/40 hover:text-white hover:border-white border-transparent "
          }`}
        >
          <h5 className="text-lg opacity-100 whitespace-nowrap"> GDPR </h5>
        </div>
      </Link>
      <Link href={Routes.DPA()} legacyBehavior>
        <div
          className={`py-1 my-3 px-3 cursor-pointer transition ${
            page === PrivacyPageType.DPA
              ? "border-l-4 border-brand-primary"
              : "border-l-4 hover:border-opacity-10 text-white/40 hover:text-white hover:border-white border-transparent "
          }`}
        >
          <h5 className="text-lg opacity-100 whitespace-nowrap"> DPA </h5>
        </div>
      </Link>
      <Link href={Routes.SubProcessors()} legacyBehavior>
        <div
          className={`py-1 my-3 px-3 cursor-pointer transition ${
            page === PrivacyPageType.SUB_PROCESSORS
              ? "border-l-4 border-brand-primary"
              : "border-l-4 hover:border-opacity-10 text-white/40 hover:text-white hover:border-white border-transparent "
          }`}
        >
          <h5 className="text-lg opacity-100 whitespace-nowrap"> Sub-Processors </h5>
        </div>
      </Link>
    </aside>)
  );
}
